import request from './request'

/**
 * 查询用户当天购买商品赠送总积分
 */
export function fetchUserIntegralToday () {
  return request({
    method: 'post',
    url: `/access/v1/user/integral/today`
  })
}

export function fetchUserCumulativeMoneyToday () {
  return request({
    method: 'get',
    url: `/access/v1/user/cumulative/money/today`
  })
}
